import { render, staticRenderFns } from "./RequestDemo.vue?vue&type=template&id=836eafca&scoped=true"
import script from "./RequestDemo.vue?vue&type=script&lang=js"
export * from "./RequestDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836eafca",
  null
  
)

export default component.exports